var map = {
  "./add_users.svg": "179815",
  "./advanced.svg": "925819",
  "./automations.svg": "406235",
  "./bamboo.svg": "672313",
  "./bounced_email.svg": "628522",
  "./calendar_integration.svg": "520280",
  "./company_directory.svg": "835942",
  "./custom_wording.svg": "456757",
  "./default.svg": "143112",
  "./design.svg": "946311",
  "./email_reports.svg": "151871",
  "./emails.svg": "770710",
  "./event_log.svg": "405388",
  "./feature_selection.svg": "436150",
  "./g2_review.svg": "850137",
  "./glossary.svg": "913833",
  "./google.svg": "775376",
  "./helpful_resources.svg": "915463",
  "./import_users.svg": "371619",
  "./kallidus.svg": "845174",
  "./license_payment.svg": "561085",
  "./mail_log.svg": "424987",
  "./message_stats.svg": "350858",
  "./module-1on1s-icon.svg": "847718",
  "./module-360-icon.svg": "196779",
  "./module-anytime-icon.svg": "333651",
  "./module-messages-icon.svg": "121636",
  "./module-objectives-icon.svg": "691352",
  "./module-praise-icon.svg": "429184",
  "./module-reviews-icon.svg": "509565",
  "./module-surveys-icon.svg": "163299",
  "./namely.svg": "276329",
  "./personio.svg": "745590",
  "./progress_o_meter.svg": "856928",
  "./referral_program.svg": "862547",
  "./retention_analytics.svg": "464208",
  "./rippling.svg": "901578",
  "./saml_sso.svg": "489246",
  "./sample_content.svg": "129573",
  "./security.svg": "653123",
  "./si_ai.svg": "709746",
  "./slack.svg": "883731",
  "./user_setting.svg": "399709",
  "./workable.svg": "241354",
  "./workday.svg": "253912"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 615985;
